import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CourseGTMService, ImpressionDirective } from '@uc/web/core';
import { Product } from '@uc/shared/data-models';
import { BookmarkComponent } from '@web/shared/ui';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CourseDetails } from '../../models/course-search.models';

@Component({
	selector: 'uc-course-card',
	templateUrl: './course-card.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [BookmarkComponent, NgClass, RouterLink, ImpressionDirective],
})
export class CourseCardComponent {
	course = input.required<CourseDetails>();
	uniId = input.required<number>();
	uniName = input.required<string>();
	uniSlug = input.required<string>();
	product = input.required<Product>();
	isFirst = input.required<boolean>();
	isLast = input.required<boolean>();
	ugSearchOrderPosition = input.required<number | null>();
	cleSearchOrderPosition = input.required<number | null>();
	searchTerm = input.required<string>();
	isHECoSSubject = input.required<boolean | null>();
	degreeLevel = input.required<string>();
	region = input.required<string>();

	constructor(private _courseGTMSrv: CourseGTMService) {}

	/*
	 * GTM Event when course profile is clicked.
	 */
	onCourseProfileClick() {
		this._courseGTMSrv.courseProfileClick(
			this.uniId(),
			this.uniName(),
			this.course().name,
			this.course().id,
			this.ugSearchOrderPosition(),
			this.cleSearchOrderPosition(),
			this.product(),
		);
	}

	onCourseImpression(impression: any) {
		if (impression) {
			this._courseGTMSrv.courseImpression(
				this.uniId(),
				this.uniName(),
				this.course().name,
				this.course().id,
				this.ugSearchOrderPosition(),
				this.cleSearchOrderPosition(),
				this.product(),
				this.isHECoSSubject(),
				this.searchTerm(),
				this.degreeLevel(),
				this.region(),
			);
		}
	}
}
